import React from 'react'
import { THEME } from 'utils'

export default function LinkIcon({ color = THEME.COLORS.TEXTCOLOR, width = '18px', height = '18px' }) {
  return (
    <svg viewBox='0 0 32.96 33' className='svgIcon iconLink' style={{ width, height, fill: color }}>
      <title>Copy Link</title>
      <path d='M15.95,23l-2.16,2.16a3.54,3.54,0,0,1-5,0l-.93-.93a3.54,3.54,0,0,1,0-5l3.9-3.9a3.54,3.54,0,0,1,5,0l1.07,1.07a1.67,1.67,0,0,0,2.36-2.36L19.11,13a6.83,6.83,0,0,0-9.65,0l-4,3.93a6.83,6.83,0,0,0,0,9.65l.93.93a6.83,6.83,0,0,0,9.65,0l2.16-2.16A1.64,1.64,0,1,0,15.95,23Z' />
      <path d='M27.46,6.5l-.87-1a6.8,6.8,0,0,0-4.83-2,6.88,6.88,0,0,0-4.86,2L15,7.4a1.67,1.67,0,1,0,2.36,2.36l1.9-1.9a3.54,3.54,0,0,1,5,0l.93.93a3.54,3.54,0,0,1,0,5l-3.66,3.63a3.54,3.54,0,0,1-5,0l-.83-.83a1.67,1.67,0,1,0-2.36,2.36l.83.83a6.8,6.8,0,0,0,4.83,2,6.69,6.69,0,0,0,4.83-2l3.63-3.63a6.83,6.83,0,0,0,0-9.65Z' />
    </svg>
  )
}
